import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, CheckCircle } from "lucide-react";

const HeroSection = () => {
  const trustBadges = [
    "Experienced Landscaping Team",
    "Transparent Written Estimates",
    "Reliable Service Scheduling",
  ];

  return (
    <section
      data-testid="hero-section"
      className="hero-section relative min-h-[90vh] flex items-center"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1770169096244-90f4288392d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxiZWF1dGlmdWwlMjBtYW5pY3VyZWQlMjBob21lJTIwZ2FyZGVuJTIwbGF3biUyMGxhbmRzY2FwaW5nfGVufDB8fHx8MTc3MjcwNjI1Mnww&ixlib=rb-4.1.0&q=85')",
        }}
      />
      
      {/* Overlay */}
      <div className="hero-overlay" />

      {/* Content */}
      <div className="relative z-10 container mx-auto max-w-7xl px-4 md:px-6 lg:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8 animate-fade-in">
            <span className="w-2 h-2 bg-[#C2410C] rounded-full" />
            <span className="text-white/90 text-sm font-medium">
              Serving Los Angeles Homeowners
            </span>
          </div>

          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-white font-bold leading-tight mb-6 animate-fade-in-up"
          >
            Local Landscaping & Gardening Services in Los Angeles
          </h1>

          {/* Subheadline */}
          <p
            data-testid="hero-subheadline"
            className="text-lg md:text-xl text-white/80 leading-relaxed mb-10 max-w-2xl animate-fade-in-up animation-delay-100"
          >
            Professional lawn care and garden maintenance tailored to your property and schedule. Transform your outdoor space with our expert team.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 animate-fade-in-up animation-delay-200">
            <Link to="/contact">
              <Button
                data-testid="hero-cta-primary"
                className="w-full sm:w-auto bg-[#C2410C] hover:bg-[#9A3412] text-white h-14 px-10 text-lg rounded-full cta-accent shadow-lg"
              >
                Request Free Estimate
              </Button>
            </Link>
            <a href="tel:+17711871113">
              <Button
                data-testid="hero-cta-secondary"
                variant="outline"
                className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-[#1A2C22] h-14 px-10 text-lg rounded-full bg-transparent"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now
              </Button>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-4 animate-fade-in-up animation-delay-300">
            {trustBadges.map((badge, index) => (
              <div
                key={index}
                data-testid={`trust-badge-${index}`}
                className="trust-badge"
              >
                <CheckCircle className="w-4 h-4 text-[#C2410C]" />
                <span className="text-white/90 text-sm">{badge}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
